const TAB_VARIANTS = {
  STANDARD: 'standard',
  PLAIN: 'plain'
};

export { TAB_VARIANTS };
